import Vue from 'vue';
import { i18n } from '../../plugins/i18n-setup';

export default function () {
  if (window.innerWidth < 1050) {
    const FormbarMobile = () => import(
      /* webpackChunkName: "FormbarMobile" */
      './FormbarMobile.vue'
    );

    FormbarMobile().then((module) => {
      new Vue({
        render: (h) => h(module.default),
        i18n,
      }).$mount('.formbar-mobile');
    });
    return;
  }

  const FormbarDesktop = () => import(
    /* webpackChunkName: "FormbarDesktop" */
    './FormbarDesktop.vue'
  );

  FormbarDesktop().then((module) => {
    new Vue({
      render: (h) => h(module.default),
      i18n,
    }).$mount('.form-bar-desktop');
  });
}
